import Modal from "@/components/ui/Modal";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { useModal } from "@/contexts/ModalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";

export default function RoomInfoModal(props) {
  const t = useTranslationDetector('hotel');
  const { roomDetail, renderImages, renderOptions, renderBookButton, isLandingPage, closeModal } = props;

  const renderFeaturesTable = useMemo(() => {
    const amenityGroups = roomDetail?.amenityGroups || [];
    const amenities =
      amenityGroups.flatMap((group) => group.Amenities || []) || [];

    if (!amenities.length) {
      return null;
    }

    const columns = 3;
    const table = [];

    // kolonlara sırayla dağıt (0,1,2,0,1,2...)
    amenities.forEach((amenity, i) => {
      const colIndex = i % columns;
      if (!table[colIndex]) table[colIndex] = [];
      table[colIndex].push(amenity);
    });

    return (
      <div className="flex gap-12 flex-wrap flex-col md:flex-row max-md:gap-5 justify-between">
        {table.map((column, idx) => (
          <div className="flex flex-col gap-6 md:gap-12" key={idx}>
            <div className="flex flex-col gap-4">
              <ul className="flex flex-col gap-3">
                {column.map((amenity, i) => (
                  <li
                    key={`roomAmenity_${amenity.AmenityId ?? i}`}
                    className="flex flex-row items-center gap-2"
                  >
                    <FontAwesomeIcon
                      icon={byPrefixAndName.far["check"]}
                      className="h-4! w-4!"
                    />
                    <span className="text-sm md:text-base">
                      {amenity.AmenityName}
                    </span>
                    {amenity.Paid && (
                      <span className="py-1 px-2 text-sm bg-[var(--color-background-global)] rounded-md">
                        {t("featurePaid")}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    );
  }, [roomDetail, t]);

  if (!roomDetail) {
    return null;
  }

  return (
    <Modal
      id={`room-info-modal-${roomDetail.id}`}
      title={t('roomDetailModalTitle')}
      className="xl:max-w-[821px] rounded-lg!"
      titleCentered
      isBottomSheet
      showCloseButton
      headerClassName="border-none pb-4"
      contentClassName="overflow-y-auto scrollbar-hide selamlar" 
      modalContainerClassName="selamlar2"
      modalClasses="selamlar3"
      size="2xl"
    >
      <div className="flex flex-col gap-6 lg:px-6 pb-6">
        {renderImages({
          containerClassName: "!max-w-full h-[376px] rounded-none",
          imageClassName: "h-[376px]",
          swiperOptions: {
            navigation: true,
            navigationPrevButtonCustomClass:
              "absolute !top-[50%] !translate-y-[-50%] !left-3 z-10 m-0 hidden !h-8 !w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-white p-[10px] shadow lg:flex",
            navigationNextButtonCustomClass:
              "absolute !top-[50%] !translate-y-[-50%] !right-3 z-10 m-0 hidden !h-8 !w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-white p-[10px] shadow lg:flex",
          }
        })}

        <div className="w-full -mt-2 max-lg:px-4 flex flex-col gap-3">
          <div className="text-[20px] text-foreground leading-[26px] lg:text-[23px] lg:leading-[30px] font-semibold">
            {roomDetail.label}
          </div>

          <div className="flex flex-row gap-4 xl:mt-3 flex-wrap">
            {roomDetail.features.map((feature, i) => (
              <div className="flex items-center gap-[6px] text-sm" key={i}>
                <FontAwesomeIcon
                  className="w-5! h-5!"
                  icon={feature.icon}
                />

                {feature.label}
              </div>
            ))}
          </div>

          <div className="w-full h-[1px] border border-solid border-border-weak hidden lg:block" />

          {renderFeaturesTable && (
            <>
              <div className="text-xl font-semibold hidden lg:block">
                {t('roomDetailAllProperties')}
              </div>

              <div className="hidden lg:flex flex-col gap-4 sm:gap-6">
                {renderFeaturesTable}
              </div>
            </>
          )}


          {!isLandingPage && renderOptions && renderOptions("text-lg xl:text-xl leading-26 font-semibold", '', 'xl:border-t xl:border-solid border-border-weak xl:pt-4 mt-2 lg:mt-1')}

          {renderBookButton({ isResponsive: false, closeModal })}


        </div>

        {
          renderFeaturesTable && (
            <div className="lg:hidden border-t border-border-weak py-6 px-4 ">
              <div className="text-lg font-semibold text-foreground mb-6">
                {t('roomDetailAllProperties')}
              </div>

              <div >
                {renderFeaturesTable}
              </div>
            </div>
          )}
      </div>
    </Modal>
  )
}